import { useState } from 'react'
import { apiUrl } from '../api/client'
import { initials } from '../lib/format'

// A person's avatar: the photo when one is on file, initials on a persona-coloured disc when not. The ring
// carries the persona (or the role when no persona is named); the size carries whatever the caller means by
// it (relationship strength on the map, a fixed size in a list). Tokens only.

export function Avatar({ name, photoUrl, persona, role, size = 32, className, ring, title }: {
  name: string; photoUrl?: string | null; persona?: string | null; role?: string | null; size?: number; className?: string
  /** override the ring hue (a token name without the leading --) */
  ring?: string; title?: string
}) {
  const [broken, setBroken] = useState(false)
  const hue = ring ?? (persona && persona !== 'other' ? `persona-${persona}` : role && role !== 'other' ? `role-${role}` : 'persona-other')
  const src = photoUrl && !broken ? apiUrl(photoUrl) : null
  return (
    <span className={`avatar ${src ? 'has-photo' : 'no-photo'} ${className ?? ''}`} style={{ width: size, height: size, ['--avatar-hue' as string]: `var(--${hue})`, fontSize: Math.max(9, Math.round(size * 0.38)) }} title={title ?? name} aria-label={name}>
      {src ? <img src={src} alt="" onError={() => setBroken(true)} /> : <span className="avatar-initials">{initials(name)}</span>}
    </span>
  )
}
